export const getFileNameFromHeader = (disposition: string | null, fallback: string) => {
  const match = disposition?.match(/filename="?([^"]+)"?/);

  return match?.[1] ?? fallback;
};
